export const planningWorkPackageLimit = 10;

export interface WorkPackagesListProps {
  setDrawerStatus: (value: boolean) => void;
}

export enum PlanningWorkPackageSlider {
  Single,
  Multiple,
  All,
}
